import {defineMessages} from 'react-intl';

export default defineMessages({
	deleteMessage: {
		id: 'flyout.myAccount.paymentMethods.deleteCard',
		defaultMessage: 'Delete'
	},
	deleteConfirmMessage: {
		id: 'flyout.myAccount.paymentMethods.deleteConfirmMessage',
		defaultMessage: 'Delete this credit card?'
	},
	submitMessage: {
		id: 'flyout.myAccount.paymentMethods.submitMessage',
		defaultMessage: 'Yes'
	},
	discardMessage: {
		id: 'flyout.myAccount.paymentMethods.discardMessage',
		defaultMessage: 'No'
	}
});
